/**
 * Lehúzásra záródás: a drawer egy "bottom sheet", és a telefonon azt várják tőle, hogy lehúzással
 * bezárható legyen (az X gomb felül van, az ujjtól messze).
 *
 * Mit lehet megfogni: a fejlécet (szállítás-sáv), a tetején lévő kis fogantyút, és az almenük felső
 * sorát. A lista görgetését nem érinti, mert a gesztus csak ezekről a fix részekről indul.
 *
 * Működés: húzás közben a lap követi az ujjat (felfelé nem mozdul), elengedéskor ha elég messze vagy
 * elég gyorsan húzták, a téma saját bezárása (header-drawer.close()) fut le, ami onnan animálja ki a
 * lapot, ahol az ujj elengedte; egyébként visszapattan. Egérrel és érintéssel is működik.
 */

const drawerDetails = document.getElementById('Details-menu-drawer-container');
const sheet = drawerDetails ? drawerDetails.querySelector('.menu-drawer') : null;
const host = drawerDetails ? drawerDetails.closest('header-drawer') : null;

const DRAG_AREAS =
  '.menu-drawer__header, .menu-drawer__grabber, .menu-drawer__submenu .menu-drawer__nav-buttons, .menu-drawer__finder-header';
const NO_DRAG_START = 'input, select, textarea';
const MOVE_THRESHOLD = 6; // ennyi px után döntjük el, hogy lehúzás-e
const CLOSE_DISTANCE = 90; // ennyi px lehúzás elég a záráshoz
const CLOSE_MIN_DISTANCE_FOR_FLICK = 30;
const CLOSE_FLICK_VELOCITY = 0.5; // px/ms

if (drawerDetails && sheet && host && typeof host.close === 'function') {
  let drag = null;
  let justDragged = false;

  const stopTracking = () => {
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onEnd);
    window.removeEventListener('pointercancel', onCancel);
    drag = null;
  };

  const snapBack = () => {
    const clear = () => {
      sheet.style.transition = '';
      sheet.style.transform = '';
      sheet.removeEventListener('transitionend', clear);
    };
    sheet.style.transition = 'transform 200ms ease';
    sheet.style.transform = 'translateY(0)';
    sheet.addEventListener('transitionend', clear);
    window.setTimeout(clear, 300);
  };

  function onMove(event) {
    if (!drag || event.pointerId !== drag.id) return;
    const dy = event.clientY - drag.startY;
    const dx = event.clientX - drag.startX;

    if (!drag.active) {
      if (Math.abs(dy) < MOVE_THRESHOLD && Math.abs(dx) < MOVE_THRESHOLD) return;
      // Vízszintes vagy felfelé húzás nem a mi dolgunk
      if (Math.abs(dx) > Math.abs(dy) || dy < 0) {
        stopTracking();
        return;
      }
      drag.active = true;
      sheet.style.transition = 'none';
    }

    drag.dy = Math.max(0, dy);
    sheet.style.transform = `translateY(${drag.dy}px)`;
  }

  function onEnd(event) {
    if (!drag || event.pointerId !== drag.id) return;
    const { active, dy, startTime } = drag;
    stopTracking();
    if (!active) return;

    // A húzás utáni "kattintást" (pl. a vissza gombon) nem engedjük át
    justDragged = true;
    window.setTimeout(() => {
      justDragged = false;
    }, 50);

    const velocity = dy / Math.max(performance.now() - startTime, 1);
    const shouldClose =
      dy > CLOSE_DISTANCE || (dy > CLOSE_MIN_DISTANCE_FOR_FLICK && velocity > CLOSE_FLICK_VELOCITY);

    if (shouldClose) {
      // A beégetett stílust és a bezárást UGYANABBAN a pillanatban vesszük le/hajtjuk végre: így a lap
      // folyamatosan, a húzás pillanatnyi helyéről csúszik ki, nem ugrik vissza előtte.
      sheet.style.transition = '';
      sheet.style.transform = '';
      window.dispatchEvent(new CustomEvent('menu-drawer:swipe-close'));
      host.close();
    } else {
      snapBack();
    }
  }

  function onCancel(event) {
    if (!drag || event.pointerId !== drag.id) return;
    const wasActive = drag.active;
    stopTracking();
    if (wasActive) snapBack();
  }

  sheet.addEventListener('pointerdown', (event) => {
    if (!drawerDetails.open) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.closest(DRAG_AREAS) || target.closest(NO_DRAG_START)) return;

    drag = {
      id: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startTime: performance.now(),
      active: false,
      dy: 0,
    };
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onEnd);
    window.addEventListener('pointercancel', onCancel);
  });

  sheet.addEventListener(
    'click',
    (event) => {
      if (justDragged) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
}
